import Axios from "axios";
import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { TargetMember } from "@/modules/targets/viewmodels/TargetMember";

export const state = {
  targetMembers: [],
};

export const getters = Object.assign(
  {
    targetMembers: (state) => {
      return state.targetMembers;
    },
    targetMember: (state) => (Id) => {
      return state.targetMembers.find((e) => e.id === Id);
    },
    targetTargetMember: (state) => (TargetId) => {
      return state.targetMembers.find((e) => e.target_id === TargetId);
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/target-members",
    TargetMember,
    {
      AfterShow: (name, data) => {
        let el = state.targetMembers.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.targetMembers.push(data);
        }
        return data;
      },
      AfterDestroy: (name, data) => {
        let element = state.targetMembers.find((e) => e.id === data);

        state.targetMembers.splice(
          state.targetMembers.findIndex((e) => e.id === data),
          1
        );

        return data;
      },
    },
    {
      //========================================================================================
      /**                                                                                     *
       * * My                                                                                 *
       * Returns all system and my targets                                                    *
       * this.$store.getters['targetmember/api'].Custom.My()                                  *
       *                                                                                      */
      //========================================================================================

      My: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call("get", process.env.VUE_APP_BASE_URL + "/api/target-members/my")
          .catch((err) => {
            throw Error(err);
          });

        let data = ApiResult.map((Entry) => {
          return new TargetMember(Entry);
        });

        Vue.set(state, "targetMembers", data);

        return data;
      },
    }
  )
);

// mutations
export const mutations = {};

const httpAxios = Axios.create({
  baseURL:
    process.env.VUE_APP_BASE_URL &&
    process.env.VUE_APP_BASE_URL !== "" &&
    process.env.VUE_APP_BASE_URL !== null
      ? process.env.VUE_APP_BASE_URL
      : "http://localhost:8888",
});

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/target-members",
  [],
  {}
);
